/**
 * Handles the logic for the one-time popup notification
 */
export function initPopupNotification() {
  const popup = document.getElementById('popup-notification');
  const closeButton = document.getElementById('closePopupNotification');
  const popupContent = popup?.querySelector('.popup-content');
  
  // Debug key as requested - change version number to reset for visitors
  const STORAGE_KEY = 'ehrenkind_popup_seen_v1';
  
  if (!popup || !closeButton) return;

  // Check if visitor has already seen the popup
  if (localStorage.getItem(STORAGE_KEY)) {
    return;
  }

  // Function to open popup with animation
  const openPopup = () => {
    popup.classList.remove('hidden');
    popup.classList.remove('pointer-events-none');
    
    // Use requestAnimationFrame to ensure transition happens
    requestAnimationFrame(() => {
      popup.classList.remove('opacity-0');
      if (popupContent) {
        popupContent.classList.remove('scale-95');
        popupContent.classList.add('scale-100');
      }
    });
    
    // Lock body scroll
    document.body.style.overflow = 'hidden';
  };

  // Function to close popup with animation
  const closePopup = () => {
    popup.classList.add('opacity-0');
    if (popupContent) {
      popupContent.classList.remove('scale-100');
      popupContent.classList.add('scale-95');
    }

    // Wait for transition to finish before hiding
    setTimeout(() => {
      popup.classList.add('hidden');
      popup.classList.add('pointer-events-none');
      document.body.style.overflow = '';
    }, 300);

    // Mark as seen
    localStorage.setItem(STORAGE_KEY, 'true');
  };

  // Open after a short delay
  setTimeout(openPopup, 2000);

  // Event Listeners
  closeButton.addEventListener('click', closePopup);

  // Close on background click
  popup.addEventListener('click', (e) => {
    if (e.target === popup) {
      closePopup();
    }
  });
  
  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !popup.classList.contains('hidden')) {
      closePopup();
    }
  });

  // Expose for debugging if needed
  (window as any).resetPopupNotification = () => {
    localStorage.removeItem(STORAGE_KEY);
  };
}

